import React, { useState, useEffect,useRef } from "react";
import deleteIcon from "../../assets/icons/delete.svg";
import { Row, Col, Form, Image, Button, Modal } from "react-bootstrap";
import Select from "react-select";
// Importing Constants from constants/adq for react-select 
import {vet,practice,entity,operators, title_suggestion, jobtype_suggestion,species_suggestion} from '../../constants/advanceQueryBuilder'
import {selectStyle} from '../../styling/select-style'

const SearchDimensions = ({ item,curr,dispatch,index,type,ind}) => {
    // for disoplaying field of multiselect
    const [showMultiSelect,setShowMultiSelect] = useState(true)
    const [multiselectValue,setMultiselectValue] = useState([])

    const [modalShow,setModalShow] =useState(false)
    const [date1,setDate1] = useState()
    const [date2,setDate2] = useState()

    const initialRender = useRef(true);
    useEffect(()=>{

        if(initialRender.current) {
            initialRender.current = false
            if(item.and.where === 'title' || item.and.where ==='v_job_types' || item.and.where === 'v_species'){
                setShowMultiSelect(true)
            }else{
                setShowMultiSelect(false)
            }
        }else{
            if(item.and.where === 'title' || item.and.where ==='v_job_types' || item.and.where === 'v_species'){
                setShowMultiSelect(true)
            }else{
                setShowMultiSelect(false)
            }
        }

    },[item.and.where])
    
    useEffect(()=>{
        if(item.and.param === 'BETWEEN' || item.and.param==='NOT BETWEEN'){
            setModalShow(true)
        }
    },[item.and.param])
    
    // useEffect(()=>{
    //     let  temp=[]
    //     multiselectValue.forEach((x)=>{
    //         temp.push(x.value)
    //     })
    //     dispatch({type:'VALUE_FIELD',val:temp.join(), index:index , val2:multiselectValue})
    // },[])
    

    const handleMultiSelectValue=(e)=>{
        setMultiselectValue(e) 
        let  temp=[]
        e.forEach((x)=>{
            temp.push(x.value)
        })
         dispatch({type:'VALUE_FIELD',val:temp.join(), index:index , val2:e})
    }

    const handleWhere=()=>{
        setMultiselectValue([])
        dispatch({type:'RESET VALUE VAL2',index:index}) 

    }

    const handleCombineDate=()=>{

        dispatch({ type: 'VALUE_FIELD', val:`${date1}___${date2}` , index: index, ind: ind }) 
        setModalShow(false)
    }

   
 
    return (
        <>
             {modalShow  &&
                <Modal
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    className='ignore-onclickoutside'
                    style={{ zIndex: '999999' }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            Date Between
                     </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Control
                            className='date-icon'
                            type="date"
                            name="date1"
                            value={date1}
                            onChange={(e) => { setDate1(e.target.value) }}
                        />
                        <Form.Control
                            className='date-icon'
                            type="date"
                            name="date2"
                            value={date2}
                            onChange={(e) => { setDate2(e.target.value) }}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={handleCombineDate} >Set Date</Button>
                    </Modal.Footer>
                </Modal>
            }
           
            <Row className="g-2">

                { index !==0 && <h6 className="mb-1 mt-3">AND</h6>}
                <>
                <Col >
                    <Select
                        className="basic-single"
                        classNamePrefix="select"
                        name="entity"
                        styles={selectStyle}
                        options={entity}
                        value={entity.find(i=>i.value === item['and'].from)}
                        onChange={(e)=>{dispatch({type:'ENTITY VALUE', entityValue:e.value ,index:index})}}
                      
                    />
                </Col>

                <Col>
                    <Select
                        className="basic-single"
                        classNamePrefix="select"
                        name="where"
                        styles={selectStyle}
                        value={item['and'].from === 'VetFields' ? vet.find(i=>i.value===item['and'].where) : practice.find(i=>i.value===item['and'].where)}
                        options={item['and'].from === 'VetFields' ? vet : practice}
                        onChange={(e)=>{dispatch({type:'WHERE FIELD', where:e.value,wheretext:e.label ,index:index});setShowMultiSelect(e.type); handleWhere() }}
                       
                    />
                </Col>
                <Col>
                    <Select
                        className="basic-single"
                        classNamePrefix="select"
                        name="val"
                        styles={selectStyle}
                        options={operators}
                        value={operators.find(i=>i.value === item['and'].param)}
                        onChange={(e)=>{dispatch({type:'OPERATOR FIELD', param:e.value,index:index})}}
                        
                    />
                </Col>

                 <Col>
                   {    showMultiSelect ?
                        <Select
                        className="basic-single"
                        classNamePrefix="select"
                        name="val"
                        styles={selectStyle}
                        isMulti
                        closeMenuOnSelect={false}
                        options={item['and'].where === 'title'? title_suggestion : item['and'].where === 'v_job_types' ? jobtype_suggestion :item['and'].where === 'v_species'? species_suggestion :null}
                        value={item.and.val2}
                        onChange={handleMultiSelectValue}
                        
                    /> :
                    <Form.Control
                        type="text"
                        placeholder="Enter value"
                        name='val'
                        value={item.and.val}
                        onChange={(e)=>{dispatch({type:'VALUE_FIELD',val:e.target.value,index:index,ind:ind})}}

                    />}      
                </Col>
                </>
                
                
                <Col className="d-flex">
                      {(index !== 0 && type==='AND') &&  
                      <div className="action-icons">
                            <span
                                className="delete-icon"
                                onClick={()=>{dispatch({type:'DELETE INPUT FIELD',index,field:type})}}
                            >
                                <Image src={deleteIcon} />
                            </span>
                      </div>}

                      {type === 'OR' &&
                          <div className="action-icons">
                          <span
                              className="delete-icon"
                              onClick={()=>{dispatch({type:'DELETE INPUT FIELD OR',index,field:type,ind})}}
                          >
                              <Image src={deleteIcon} />
                          </span>
                        </div>

                      }
                    <> 
                    <Button onClick={() => { dispatch({type:'ADD INPUT FIELD'})}} className="btn theme-btn-grey ms-2">AND</Button>
                    <Button onClick={() => { dispatch({type:'ADD INPUT FIELD OR',index:index})}}  className="btn theme-btn-grey ms-2">OR</Button>
                    </> 
                </Col>
            </Row>
        </>
    );
};

export default SearchDimensions;